import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useApi2 } from 'containers/Api2/index.js';
import Select from 'components/tags/Select/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import { idValues } from 'utils/arrays.js';
import Form4SingleField from 'components/interaction/Form4/Form4SingleField.jsx';
import useSchoolSettings from '../../hooks/useSchoolSettings.js';
import messages from './messages.js';

function Language() {
  const languages = useApi2({ url: 'languages' });
  const { settings, changeDetail } = useSchoolSettings();
  const { id, name } = settings.language;
  if (languages.loading) {
    return <Spinner />;
  }
  const options = {
    id: 'language',
    as: Select,
    attributes: { options: idValues(languages).map((o) => ({ value: o.id, label: o.name })) },
    itemToString: () => name,
  };
  return (
    <div>
      <h3><FormattedMessage {...messages.header} /></h3>
      <p className="form-text"><FormattedMessage {...messages.intro} /></p>
      <div className="mb-4">
        <Form4SingleField
          value={id}
          options={options}
          onChange={(key, val) => changeDetail('language', { id: val })}
        />
      </div>
    </div>
  );
}

export default Language;
